import { type CareerProfile } from 'CareerProfiles';
import { locationString, placeCountry } from 'Location';

export const messagingLocation = (profile: CareerProfile) => {
    if (!profile) return '';

    const country = placeCountry(profile.placeDetails) === 'US' ? 'USA' : null;
    return [locationString(profile.placeDetails), country].filter(Boolean).join(', ') || '';
};
